module.exports = __webpack_public_path__ + "static/media/checkmark.4c8e70c7.svg";